var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.526 6.21349C5.8365 6.21349 6.0885 6.46549 6.0885 6.77599C6.0885 7.08649 5.8365 7.33849 5.526 7.33849H4.82625C3.612 7.33849 2.625 8.32549 2.625 9.53899V13.1952C2.625 14.4095 3.612 15.3965 4.82625 15.3965H13.1737C14.3873 15.3965 15.375 14.4095 15.375 13.1952V9.53224C15.375 8.32249 14.391 7.33849 13.182 7.33849H12.4748C12.1643 7.33849 11.9123 7.08649 11.9123 6.77599C11.9123 6.46549 12.1643 6.21349 12.4748 6.21349H13.182C15.0113 6.21349 16.5 7.70224 16.5 9.53224V13.1952C16.5 15.0297 15.0075 16.5215 13.1737 16.5215H4.82625C2.9925 16.5215 1.5 15.0297 1.5 13.1952V9.53899C1.5 7.70524 2.9925 6.21349 4.82625 6.21349H5.526ZM9.39795 1.28419L11.5849 3.48019C11.804 3.70069 11.8032 4.05619 11.5835 4.27519C11.363 4.49419 11.0075 4.49419 10.7885 4.27369L9.56175 3.04275L9.5622 11.2737H8.4372L8.43675 3.04275L7.2117 4.27369C7.1022 4.38469 6.95745 4.43944 6.81345 4.43944C6.6702 4.43944 6.5262 4.38469 6.4167 4.27519C6.19695 4.05619 6.19545 3.70069 6.4152 3.48019L8.60145 1.28419C8.8122 1.07194 9.1872 1.07194 9.39795 1.28419Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.f4a3e1c0.svg";
export { ForwardRef as ReactComponent };